var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgShenpi = function SvgShenpi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "shenpi_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8680",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6860",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#shenpi_svg__a)",
    width: 32,
    height: 32,
    rx: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.923 24H9.077a.58.58 0 0 1-.577-.579c0-.318.26-.551.577-.551h13.846c.317 0 .577.233.577.551a.58.58 0 0 1-.577.579Zm0-2.107H9.077a.58.58 0 0 1-.577-.579V18.42c0-.955.779-1.736 1.73-1.736h3.693c-.115-.695-.461-1.36-.952-1.94a4.053 4.053 0 0 1-1.01-2.69c0-1.1.433-2.142 1.241-2.924.808-.781 1.846-1.157 2.971-1.128 2.077.086 3.837 1.88 3.865 3.964.03 1.042-.375 2.055-1.067 2.837-.49.52-.779 1.157-.894 1.88h3.692c.952 0 1.731.782 1.731 1.737v2.894a.58.58 0 0 1-.577.579Z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
};

export default SvgShenpi;